import { css } from '@emotion/css';
import { Colors } from '../../../shared/styles/colors';
import { labelStyle, tabularNumbersStyle } from '../../../shared/styles/text';
import { Socket, Source } from '../../../shared/types/server-types';
import { Motion, Radius } from '../../../shared/styles/tokens';

export const sourceModalStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 1.5rem calc(0.5rem + env(safe-area-inset-bottom, 0px)) 1.5rem;
  width: 100%;
  max-width: 27rem;
  margin: 0 auto;
  label {
    ${labelStyle.toString()}
    color: ${Colors.TEXT_SECONDARY};
    text-transform: capitalize;
  }
`;

export const pullTabStyle = css`
  align-self: center;
  width: 80px;
  height: 4px;
  background: ${Colors.BORDER_STRONG};
  border-radius: 2px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const modalHeaderStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  text-transform: capitalize;
  margin-bottom: 1rem;

  > div {
    min-width: 0;
  }

  > div > p {
    color: ${Colors.TEXT_SECONDARY};
    margin-bottom: 0.125rem;
  }

  > div > h1 {
    overflow-wrap: anywhere;
  }
`;

export const iconStyle = css`
  width: 3.5rem;
  height: 3.5rem;
  flex: 0 0 auto;
  align-self: center;
  padding: 0.625rem;
  border-radius: 50%;
  background: ${Colors.SURFACE};
`;

/** Status pills: green when the state is good, red otherwise. */
export const statusSignalsStyle = (source: Source): string => css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  span {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    border: 1px solid ${Colors.ERROR_DARK}55;
    background: ${Colors.ERROR_TINT};
    color: ${Colors.ERROR_DARK};
    font-weight: bold;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 0.375rem 0.75rem;
    border-radius: ${Radius.pill};
    text-transform: capitalize;
    transition:
      background-color ${Motion.base},
      border-color ${Motion.base},
      color ${Motion.base};

    &::before {
      content: '';
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      background: currentColor;
    }
  }
  span#available {
    ${source.state.activated === false &&
    css`
      border-color: ${Colors.SUCCESS}55;
      background: ${Colors.SUCCESS_TINT};
      color: ${Colors.SUCCESS};
    `}
  }
  span#plugged {
    ${(source as Socket).state.socketStable === true &&
    css`
      border-color: ${Colors.SUCCESS}55;
      background: ${Colors.SUCCESS_TINT};
      color: ${Colors.SUCCESS};
    `}
  }
  svg {
    align-self: center;
    color: ${Colors.TEXT_SECONDARY};
  }
`;

export const sourceInfoStyle = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 0.75rem;
  width: 100%;
  margin: 1.25rem 0px;
  div {
    min-width: 0;
    p {
      ${tabularNumbersStyle}
      text-transform: capitalize;
      margin-top: 0.25rem;
      overflow-wrap: anywhere;
    }
  }
`;

export const activationInfoStyle = css`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const activationInfoLabelStyle = css`
  width: 50%;
  display: flex;
  margin: 1.25rem 0px;
  min-width: 0;

  p {
    ${tabularNumbersStyle}
    margin-top: 0.25rem;
    overflow-wrap: anywhere;
  }
`;

export const activateButtonStyle = css`
  min-width: 100%;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 1.5rem;
  }
`;
